import { useState } from 'react'

import { toast } from 'react-toastify'

import { AuthErrorCodes } from 'constants/index'
import { ResendEmailConfirmationToUser } from 'services/IdentityApiClient'

export const useResendEmailConfirmation = () => {
  const [resendingConfirmation, setResendingConfirmation] = useState(false)

  const handleResendConfirmation = (username: string) => {
    setResendingConfirmation(true)
    ResendEmailConfirmationToUser(username)
      .then(() => toast.success("The Verification Email has been sent successfully"))
      .catch((error) => {
        if (error.response?.data?.code === AuthErrorCodes.EmailAlreadyConfirmed) {
          toast.warning('This email is already confirmed')
        } else {
          toast.error('Failed to resend email confirmation')
        }
      })
      .finally(() => setResendingConfirmation(false))
  }

  return { resendingConfirmation, handleResendConfirmation }
}

